import React, {useState, useEffect, useCallback}  from 'react';
import {Link} from 'react-router-dom';
import LogoSideBar from '../../shop/components/images/navbar/LogoW250.png';
import {useCategories } from '../../components/hooks/hooks-e-commerce/useCategories';
import {useGroups} from '../../components/hooks/hooks-e-commerce/useGroups';
import './sidebarstore.scss';

export function SideBarStore({global}) {

    const [width, setWidth] = useState(0);
    const [fullSideBar, setFullSideBar] = useState(false);
    const [isSideBarHidden, setIsSideBarHidden] = useState(false);
    const {categories} = useCategories();
    const {groups} = useGroups();
    
    const elencoGruppi = groups.map(item => ({
        nome: item.nome,
        id_categoria: item.id_categoria_prodotto,
        collegamento: item.collegamento,
        icon_categoria: item.icon_categoria
    }));

    const handleWidthResize = useCallback(() => { 
        const toggleWidth = window.innerWidth; 
        setWidth(toggleWidth); 
        setFullSideBar(toggleWidth <= 1100);
    }, []);

     // ✅ 3. Gestisci resize window
    useEffect(() => {
        window.addEventListener("resize", handleWidthResize);
        handleWidthResize();
        
        return () => {
            window.removeEventListener("resize", handleWidthResize);
        };
    }, [handleWidthResize, width]);

    return (
        <>
        {!fullSideBar ? 
        (<aside className='store-nav-sidebar__up'>
            <div className="sidebar__head-info">
                <div className="sidebar__title">
                    <h1>Negozio Online</h1>
                    <img src={LogoSideBar} alt="logo of the site" />
                </div>
                <div className="sidebar__welcome">Benvenuto!</div>
                <div className="sidebar__login-prompt">
                    <Link to="/login" className="sidebar__login-link"> Accedi </Link> 
                    <span>per vedere i tuoi sconti</span>
                </div>
            </div>

            <nav className="categories-sidebar__nav">
                <ul>
                    {categories.map((categoria) => {
                        return (
                            <li key={categoria.id}>
                                <Link to={categoria.collegamento}>
                                    <div className="sidebar__category">
                                        <span className="category__icon">{categoria.icon_categoria}</span>
                                        <span className="category__text">{categoria.nome}</span>
                                    </div>    
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>
            <div className="sidebar-footer"></div>
            <div className="footer-infos realistic">
                <Link to="/negozioonline/zonaartigianale">
                    <p className='mt-12'>ZONA </p>
                    <p className='mb-12'>ARTIGIANALE</p>    
                </Link>
            </div>
        </aside>
                ) : (
        <aside className={`store-nav-sidebar__down ${isSideBarHidden ? 'open' : ''}` }>
            <div className="sidebar__zonartiginale">
                <Link to="/negozioonline/zonaartigianale">
                        <p className='mb-12'>ZONA</p>
                        <p>ARTIGIANALE</p>    
                </Link>
            </div>
            <div className="sidebar__welcome ml-12">Benvenuto!</div>
            
            <div className="sidebar__login-prompt ml-12">
                <Link to="/login" className="sidebar__login-link"> Accedi </Link> 
                <span>per vedere i tuoi sconti</span>
            </div>
            <div className="sidebar__headown-info"></div>
            
            <nav className="sidebar__nav">    
                <ul className="sidebar__menu">
                    {categories.map((categoria) => {
                        const submenuItems = elencoGruppi.filter(
                            item => item.id_categoria === categoria.id
                        );
                        return (
                            <li key={categoria.id} className="sidebar__menu-item">
                                <Link to={categoria.collegamento}>
                                    <p className="sidebar__menu-link">
                                        <span className="sidebar__menu-text">{categoria.nome}</span>
                                    </p>
                                </Link>
                                
                                {submenuItems.length > 0 && (
                                    <ul className="sidebar__submenu">
                                        {submenuItems.map((subItem, index) => (
                                            <li key={`${categoria.id}-${index}`} >
                                                <Link  to={subItem.collegamento} className="sidebar__submenu-link" >
                                                    {subItem.nome}
                                                </Link> 
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>
            <div className="sidebar-footer"></div>
            <div className="footer-icon__site">
                <img src={LogoSideBar} alt="logo of the site" />
            </div>
        </aside>)}
        <button 
                className={`sidebar-toggle-btn ${isSideBarHidden ? 'active' : ''}`}
                onClick={() => setIsSideBarHidden(!isSideBarHidden)}
                aria-label="Toggle Sidebar"
            >
                <span className="sidebar-toggle-icon">
                    {isSideBarHidden ? (
                        '✕'
                    ) : (
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 20 20"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            >
                            <path d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"/>
                            <path d="M9 4v16"/>
                        </svg>
                    )}
                </span>
            </button>
        </>
    );
}
